export default __webpack_public_path__ + "static/media/b6.7b1281d3.webp";